import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { artavaBrand } from '../branding/artavaBrand';
import styles from './LoadingScreen.module.css';

const LoadingScreen = () => {
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const isItalian = i18n.language?.startsWith('it');
  const messages = useMemo(() => (
    isItalian
      ? [
          'Avvio del workspace Smarti...',
          'Preparazione dei dati e dei controlli di sessione...',
          'Caricamento dei modelli e dei componenti di analisi...',
          'Sincronizzazione dell ambiente di produzione...',
          'Quasi pronto: stiamo aprendo la tua area di lavoro.',
        ]
      : [
          'Starting the Smarti workspace...',
          'Preparing data and session checks...',
          'Loading models and analysis components...',
          'Synchronizing the production environment...',
          'Almost ready: opening your workspace now.',
        ]
  ), [isItalian]);

  useEffect(() => {
    const messageInterval = setInterval(() => {
      setCurrentMessageIndex((prevIndex) => (prevIndex + 1) % messages.length);
    }, 3000);

    const redirectTimeout = setTimeout(() => {
      navigate('/dashboard');
    }, 15000);

    return () => {
      clearInterval(messageInterval);
      clearTimeout(redirectTimeout);
    };
  }, [messages.length, navigate]);

  return (
    <div className={styles.loadingContainer}>
      <div className={styles.brandShell}>
        <div className={styles.brandHeader}>
          <img src={artavaBrand.logoSrc} alt={artavaBrand.companyName} className={styles.companyLogo} />
          <div>
            <p className={styles.eyebrow}>{artavaBrand.companyName}</p>
            <h1 className={styles.title}>{artavaBrand.productName}</h1>
            <p className={styles.subtitle}>
              {isItalian ? 'Workspace analytics per produzione, burn-in e team engineering.' : 'Analytics workspace for production, burn-in, and engineering teams.'}
            </p>
          </div>
        </div>
        <img
          src="/images/Loading.gif"
          alt={isItalian ? 'Indicatore di caricamento Smarti' : 'Smarti loading indicator'}
          className={styles.aiIcon}
        />
        <p className={styles.loadingMessage}>{messages[currentMessageIndex]}</p>
      </div>

      <footer className={styles.footer}>
        <p className={styles.footerText}>
          {isItalian ? 'Smarti e sviluppato da Artava Systems.' : 'Smarti is built by Artava Systems.'}
        </p>
        <div className={styles.footerLinks}>
          <a href={`mailto:${artavaBrand.contactEmail}`} className={styles.footerLink}>{artavaBrand.contactEmail}</a>
          <a href={artavaBrand.websiteUrl} target="_blank" rel="noopener noreferrer" className={styles.footerLink}>
            {artavaBrand.websiteHost}
          </a>
        </div>
      </footer>
    </div>
  );
};

export default LoadingScreen;
